import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseBreadcrumbDivider   = {
  marginInline: css`var(--cse-breadcrumb-divider-margin-x, ${csSpacing.spacing04})`, 
  color: css`var(--cse-breadcrumb-divider-color, ${csColorText.muted})`,
  size: css`var(--cse-breadcrumb-divider-size, 14px)`,
}

export const style: CSSResult = css`
  .cse-breadcrumb-divider {
    --cse-icon-color: ${cseBreadcrumbDivider.color};
    align-items: center;
    display: flex;
    margin-inline: ${cseBreadcrumbDivider.marginInline};
  }

  .icon {
    font-size: ${cseBreadcrumbDivider.size};
  }
`
